import axios from "axios";
import { useParams } from "react-router-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";

import config from "./config";
import { useToast } from "./hooks/ToastContext";

import {
  ArrowRightStartOnRectangleIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";

import { useCookies } from "react-cookie";
import { useLoader } from "./hooks/LoaderContext";
import QRCode from "react-qr-code";

const FeQrCodePage = () => {
  const { id } = useParams();
  const { showToast } = useToast();
  const hasFetched = useRef(false);
  const [qrsetting, setqrsetting] = useState({});
  const feqrcodeDetails = useCallback(async () => {
    try {
      let payload = {
        contest_id: id,
      };
      const res = await axios.post(
        `${config.API_URL}/get-qrcode-settings`,
        payload
      );
      if (res.status === 200 && res.data?.widget_settings) {
        const settings = JSON.parse(res.data.widget_settings);
        setqrsetting(settings);
      }
    } catch (error) {
      console.log(error);
    }
  }, [id]);

  useEffect(() => {
    if (!hasFetched.current) {
      feqrcodeDetails();
      hasFetched.current = true;
    }
  }, [feqrcodeDetails]);

  return (
    <>
      {/* <div style={{ textAlign: "center", padding: "2rem" }}>
      {qrsetting?.contest_url ? (
        <div
          style={{
            height: "auto",
            margin: "0 auto",
            maxWidth: 256,
            width: "100%",
          }}
        >
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={qrsetting.contest_url || ""}
            viewBox="0 0 256 256"
          />
          <p style={{ marginTop: "1rem" }}>{qrsetting.contest_url}</p>
          <p style={{ marginTop: "1rem" }}>{qrsetting?.qr_text1}</p>
          <p style={{ marginTop: "1rem" }}>{qrsetting?.bgLogo}</p>
        </div>
      ) : (
        <p>Loading QR code...</p>
      )}
    </div> */}

      <div className="flex flex-col items-center justify-center min-h-screen bg-black p-4 sm:p-6 md:p-8">
        {/* Logo Section */}
        <div className="flex justify-center mb-6 sm:mb-8">
          {qrsetting?.bgLogo && (
            <div className="flex items-center justify-center">
              <img
                src={
                  qrsetting?.bgLogo ||
                  "	https://img.flexifunnels.com/flexicontest/default_logo_bg.jpg"
                }
                alt="Logo"
                className="fill-current text-gray-500 w-[100px] h-[50px] md:w-[200px] md:h-[50px] rounded"
              />
            </div>
          )}
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 md:p-10 max-w-md w-full">
          {/* Text 1 - Above QR Code */}
          <div className="text-center mb-4 sm:mb-6">
            {qrsetting?.qr_text1 && (
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                {qrsetting?.qr_text1}
              </h2>
            )}
            {qrsetting?.qr_text1 && (
              <p className="text-sm sm:text-base text-gray-600">
                {qrsetting?.qr_text2}
              </p>
            )}
          </div>

          {/* QR Code with Green Border */}
          <div className="flex justify-center mb-4 sm:mb-6">
            <div className="relative">
              {/* Black decorative corners */}
              <div className="absolute -top-2 -left-2 w-6 h-6 border-t-4 border-l-4 border-black rounded-tl-lg"></div>
              <div className="absolute -top-2 -right-2 w-6 h-6 border-t-4 border-r-4 border-black rounded-tr-lg"></div>
              <div className="absolute -bottom-2 -left-2 w-6 h-6 border-b-4 border-l-4 border-black rounded-bl-lg"></div>
              <div className="absolute -bottom-2 -right-2 w-6 h-6 border-b-4 border-r-4 border-black rounded-br-lg"></div>

              {/* QR Code Container */}
              <div className="border-4 border-black rounded-xl p-4 sm:p-5 md:p-6 bg-white shadow-lg">
                <QRCode
                  size={200}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={qrsetting.contest_url || ""}
                  viewBox="0 0 256 256"
                  level="H"
                />
              </div>
            </div>
          </div>

          {/* Text 2 - Below QR Code */}
          <div className="text-center mb-4 sm:mb-5">
            {qrsetting?.qr_text1 && (
              <p className="text-xs sm:text-sm text-gray-500 mt-1">
                {qrsetting?.qr_text3}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FeQrCodePage;
